export type { TabContentTranslations } from "./tab-content-pt-br";
export { TAB_CONTENT_PT_BR } from "./tab-content-pt-br";
export { TAB_CONTENT_EN_US } from "./tab-content-en-us";
export { TAB_CONTENT_FR_FR } from "./tab-content-fr-fr";
export { TAB_CONTENT_ES_MX } from "./tab-content-es-mx";
